var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDownColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_2156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 10.833L10.8334 18.333C10.1703 18.333 9.53443 18.0696 9.06559 17.6008C8.59675 17.1319 8.33336 16.496 8.33336 15.833V12.4997H3.61669C3.3751 12.5024 3.13581 12.4526 2.91538 12.3536C2.69496 12.2547 2.49868 12.109 2.34014 11.9267C2.18161 11.7444 2.0646 11.5298 1.99724 11.2978C1.92988 11.0657 1.91377 10.8219 1.95003 10.583L3.10003 3.08298C3.16029 2.68556 3.36216 2.32331 3.66844 2.06298C3.97471 1.80265 4.36475 1.66177 4.76669 1.66632H14.1667M14.1667 10.833V1.66632M14.1667 10.833H16.3917C16.8633 10.8413 17.3216 10.6762 17.6795 10.369C18.0375 10.0617 18.2701 9.63377 18.3334 9.16632V3.33298C18.2701 2.86553 18.0375 2.43757 17.6795 2.13033C17.3216 1.8231 16.8633 1.65798 16.3917 1.66632H14.1667",
    stroke: "#E54E4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_2156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownColor);
export default __webpack_public_path__ + "static/media/thumbsDownColor.b5a9f927b85d2835b6806f5958032213.svg";
export { ForwardRef as ReactComponent };